import marquee from "vanilla-marquee";

const marquee_mark = () => {
    const marquee_right = document.querySelectorAll('.js-marquee-right');

    marquee_right.forEach(marqueeItemRight => {
        new marquee(marqueeItemRight, {
            duplicated: true,
            gap: '24px',
            direction: 'right',
            speed: 30,
            startVisible: true
        });
    });
}

export default marquee_mark;